import { render, staticRenderFns } from "./FLVPlayer.vue?vue&type=template&id=2e2d9770"
import script from "./FLVPlayer.vue?vue&type=script&lang=js"
export * from "./FLVPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports